/*
 * Simple Bundels
 */
window.addEventListener('DOMContentLoaded', () => {

  const bundleParent = document.querySelector('[data-simple-bundles]');
  if (!bundleParent)
    return;

  const productOptionsJson = JSON.parse(document.querySelector('#bundle-variants').textContent);
  const productsJson = JSON.parse(document.querySelector('#bundle-products').textContent);

  const mapProductOptions = () => productOptionsJson.map(product => {
    const inventories = product.optionInventories?.split(',');
    const optionValues = product.optionValues.split(',');

    return optionValues.map((option, i) => {
      const nameSplit = option.split(' - ');
      const title = nameSplit[0].trim();
      const variantString = nameSplit[1];
      
      // If the product has color option, we need to offset the property splits by 1, so we don't get the color option.
      const hasColor = !!productsJson
        .find(p => p.title == title)?.options
        .find(o => o == window.themeVariables.strings.colorLabel);

      let property1 = '';
      let property2 = '';

      if (variantString.includes(' / ')) {
        const split = variantString.split(' / ');
        property1 = split[hasColor ? 1 : 0];
        property2 = split[hasColor ? 2 : 1];
      } else {
        property1 = variantString;
      }

      return {
        title: title,
        property1: property1 ? String(property1).trim() : undefined,
        property2: property2 ? String(property2).trim() : undefined,
        available: inventories ? inventories[i] > 0 : false
      }
    });
  }).flat();
  const mappedProductOptions = mapProductOptions();
  
  const addToCartBtns = document.querySelectorAll('form[action="/cart/add"] button[type="submit"]');
  const bundleOptions = document.querySelectorAll('[data-variant-options]');
  const bundleProperty = document.querySelectorAll('form[action="/cart/add"] input[name="properties[_bundle_selection]"]');

  const updateButton = () => {
    const selectedStrings = Array.from(bundleOptions).map(option => {
      const selectedProduct = option.querySelector('[data-variant-title-value][data-selected]');
      const selectedProductTitle = selectedProduct.dataset.variantTitleValue;
      const selectedProductColor = selectedProduct.dataset.variantOptionColor;

      const visibleOptionsForTitles = option.querySelectorAll('[data-options-for-title]:not([hidden])');
      const selectedOptionsForTitles = Array.from(visibleOptionsForTitles).map(oft => oft.querySelector("[data-selected]"));
      const mappedSelectedOptions = selectedOptionsForTitles.map(selected => selected?.dataset?.value);

      if (mappedSelectedOptions.some(item => item === undefined)) {
        addToCartBtns.forEach(btn => {
          btn.disabled = true;
          btn.textContent = window.themeVariables.strings.selectVariantButton;
        });
      } else {
        addToCartBtns.forEach(btn => {
          btn.disabled = false;
          btn.textContent = window.themeVariables.strings.addToCartButton;
        });
      }

      let selectedOptionsValues = [...mappedSelectedOptions];
      if (selectedProductColor != '') {
        selectedOptionsValues = [selectedProductColor, ...selectedOptionsValues]
      }

      return `${selectedProductTitle} - ${selectedOptionsValues.join(' / ')}`;
    });

    bundleProperty.forEach(bp => bp.value = selectedStrings.join(' <> '));
    productOptionsJson
      .map(options => options.optionName)
      .forEach((name, i) => {
        const optionProperties = document.querySelectorAll(`form[action="/cart/add"] input[name="properties[${name}]"`);
        optionProperties.forEach(property => property.value = selectedStrings[i]);
      })
  }

  const updateAvailability = (selectedProductTitle, productOptionValue, optionIndex) => {
    const optionsForTitles = document.querySelectorAll(`[data-options-for-title="${selectedProductTitle}"]`);

    if (optionsForTitles.length == 1) {
      const products = mappedProductOptions.filter(p => p.title == selectedProductTitle);

      optionsForTitles.forEach((options, i) => {
        const values = options.querySelectorAll('[data-value]');

        values.forEach(value => {
          const product = products.find(o => o[`property${i + 1}`] == value.dataset.value);
          
          if (!product || !product.available) {
            value.setAttribute('disabled', true);
          } else {
            value.removeAttribute('disabled');
          }
        });
      });
    } else if (productOptionValue) {
      // Get the opposite list of the selected index, to update its availability
      let oppositeIndex = 0;
      if (optionIndex == 0) {
        oppositeIndex = 1
      } else {
        oppositeIndex = 0
      }

      const products = mappedProductOptions.filter(p => p.title == selectedProductTitle && p[`property${optionIndex + 1}`] == productOptionValue);
      const indexValues = optionsForTitles[oppositeIndex].querySelectorAll('[data-value]');

      indexValues.forEach((value, i) => {
        const product = products[i];

        if (!product || !product.available) {
          value.setAttribute('disabled', true);
          value.removeAttribute('selected');
        } else {
          value.removeAttribute('disabled');
        }
      });
    }
  }

  bundleOptions.forEach(bundleOption => {
    const titleElement = bundleOption.querySelector('[data-product-title]')
    const productOptions = bundleOption.querySelectorAll(`[data-options-for-title]`);
    const productSelectors = bundleOption.querySelectorAll('[data-variant-title-value]');

    productSelectors.forEach(productSelector => {
      const title = productSelector.dataset.variantTitleValue;

      updateAvailability(title);

      productSelector.addEventListener('click', () => {
        bundleOption.querySelectorAll('[data-value]').forEach(val => val.removeAttribute('data-selected'));
        productSelectors.forEach(selector => selector.removeAttribute('data-selected'));
        productSelector.setAttribute('data-selected', true);

        productOptions.forEach(options => {
          titleElement.textContent = title;
          const values = options.querySelectorAll('[data-value]');
          values.forEach(val => {
            val.removeAttribute('disabled');
            val.removeAttribute('selected');
          });
          options.hidden = true;
          if (options.dataset.optionsForTitle == title) {
            options.hidden = false;
          }
        });
        updateAvailability(title);
        updateButton();
      });
    });

    productOptions.forEach((productOption) => {
      const values = productOption.querySelectorAll('[data-value]');
      values.forEach(val => val.addEventListener('click', () => {
        if (val.hasAttribute('disabled')) {
          return;
        }

        values.forEach(v => v.removeAttribute('data-selected'));
        val.setAttribute('data-selected', true);

        const visibileOptions = bundleOption.querySelectorAll(`[data-options-for-title]:not([hidden])`);
        const currentOptionIndex = Array.from(visibileOptions).findIndex(o => o == productOption);

        updateAvailability(productOption.dataset.optionsForTitle, val.dataset.value, currentOptionIndex);
        updateButton();
      }));
    });
  });
});
